import React, { CSSProperties } from 'react'
import clsx from 'classnames'
import style from './tag.module.scss'

type TagProps = React.HTMLProps<HTMLDivElement>

export const Tag = (props: TagProps) => {
  const { className, children, color = 'main-blue', style: restStyle } = props

  return (
    <span
      className={clsx(style.container, 'text text_type_d', className)}
      style={{ ...restStyle, '--tag-color': color.startsWith('#') ? color : `var(--${color})` } as CSSProperties}
    >
      {children}
    </span>
  )
}
